import { PopoverPosition as BlueprintPopoverPosition } from '@blueprintjs/core';
import { Popover2 } from '@blueprintjs/popover2';
import { Copy, OverflowMenuHorizontal, TrashCan } from '@carbon/icons-react';
import classNames from 'classnames';
import * as React from 'react';
import {
  Button,
  MenuItem,
  MenuItems,
} from 'vet-bones/design-system/components';

import {
  getOverviewDrawerDeleteTestId,
  getOverviewDrawerDuplicateTestId,
  getOverviewDrawerMenuButtonTestId,
} from 'src/constants/testIds';
import { ModelRule } from 'src/containers/ProjectDiagram/types/data';
import * as copy from 'src/templates/copy';
import { stopPropagation } from 'src/utils/handlers/stopPropagation';

type ProjectRuleOverviewMenuProps = {
  idx: number;
  onDelete: () => void;
  onDuplicate: () => void;
  rule: ModelRule;
};

export const ProjectRuleOverviewMenu: React.VFC<
  ProjectRuleOverviewMenuProps
> = ({ idx, onDelete, onDuplicate, rule }) => (
  // eslint-disable-next-line jsx-a11y/no-static-element-interactions
  <div onClick={stopPropagation}>
    <Popover2
      content={
        <MenuItems>
          <MenuItem
            leftIcon={Copy}
            onClick={onDuplicate}
            testId={getOverviewDrawerDuplicateTestId(rule.id, idx)}
            text={copy.components.projectRuleOverviewDrawer.duplicate}
          />
          <MenuItem
            leftIcon={TrashCan}
            onClick={onDelete}
            testId={getOverviewDrawerDeleteTestId(rule.id, idx)}
            text={copy.components.projectRuleOverviewDrawer.delete}
          />
        </MenuItems>
      }
      minimal
      popoverClassName={classNames(
        'vb-menu-popover',
        `vb-popover-position--${BlueprintPopoverPosition.BOTTOM_RIGHT}`
      )}
      position={BlueprintPopoverPosition.BOTTOM_RIGHT}
    >
      <Button
        leftIcon={OverflowMenuHorizontal}
        size="2xs"
        testId={getOverviewDrawerMenuButtonTestId(rule.id, idx)}
        variant="ghost-gray"
      />
    </Popover2>
  </div>
);
